/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSaveUserTermsStatusRequestFromJSON(json) {
    return StreemApiSaveUserTermsStatusRequestFromJSONTyped(json, false);
}
export function StreemApiSaveUserTermsStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'acceptedLatest': !exists(json, 'accepted_latest') ? undefined : json['accepted_latest'],
    };
}
export function StreemApiSaveUserTermsStatusRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accepted_latest': value.acceptedLatest,
    };
}
//# sourceMappingURL=StreemApiSaveUserTermsStatusRequest.js.map